/**
 * @generated SignedSource<<ae3e9a1371cfa087f019b268a6f9bd4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useHandleTemplateChange$data = {
  readonly issueForm: {
    readonly " $fragmentSpreads": FragmentRefs<"useHandleTemplateChangeIssueForm">;
  } | null | undefined;
  readonly issueTemplate: {
    readonly __typename: "IssueTemplate";
    readonly assignees: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename?: "User";
          readonly avatarUrl?: string;
          readonly id?: string;
          readonly login?: string;
          readonly name?: string | null | undefined;
          readonly profileResourcePath?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly body: string | null | undefined;
    readonly filename: string;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly color: string;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly nameHTML: string;
          readonly url: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly title: string | null | undefined;
    readonly type: {
      readonly color: IssueTypeColor;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly isEnabled: boolean;
      readonly name: string;
      readonly pinnedFields: ReadonlyArray<{
        readonly __typename: "IssueFieldDate";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldMultiSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldNumber";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldSingleSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldText";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useHandleTemplateChange";
};
export type useHandleTemplateChange$key = {
  readonly " $data"?: useHandleTemplateChange$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHandleTemplateChange">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useHandleTemplateChange"
};

(node as any).hash = "abc29678778006de453c21a92b2137db";

export default node;
